import axios, { AxiosRequestConfig } from "axios";

const url = `${process.env.FOSFEC_MAIN_URL}`;
const saveFormUrl = `${process.env.FOSFEC_SAVE_FORM_URL}`;
const apikey = `${process.env.CONSULTA_SERVICIO_APORTANTE_API_KEY}`;

const getDdlMasters = async () => {
    const data = await axios.get(
        `${url}/ddl`
    );
    return data;
};

const getRegistry = async (dataBody : dataRegistry, token : string ) => {
    const data = await axios.post(
        `${url}/registry`,
        dataBody,
        {
            headers: {
                Authorization:  `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );
    return data;
};

const getSapFosfecState = async (dataSapFosfecSate : dataSapFosfecSate, token : string ) => {
    const data = await axios.post(
        `${url}/statusSap`,
        dataSapFosfecSate,
        {
            headers: {
                Authorization:  `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );
    return data;
};

const saveFormFosfec = async (payLoadForm: any, token: string) => {
    const data = await axios.post(saveFormUrl, JSON.stringify(payLoadForm), {
        headers: {
            'Content-Type': 'application/json',
            'apikey': apikey,
            Authorization: token,
        },
    });
    return data;
};

const consultDocuments = async (dataConsulDocs : dataConsulDocs[]) => {
    const data = await axios.post(
        `${url}/consultDocuments`,
        JSON.stringify(dataConsulDocs),
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );
    return data;
};

const getBpByTypeDocAndDoc = async (tipoDocumento : string, numeroDocumento: string, token : string ) => {
    
    const headers = {
        Accept: 'application/json',
        tipoDocumento,
        numeroDocumento,
        Authorization: `Bearer ${token}`,
      };
    
      const config: AxiosRequestConfig = {
        headers,
      };
    const data = await axios.get(
        `${url}/getBpByTypeDocAndDoc`, config
    );
    return data;
};

type dataRegistry = {
    typeDoc: string;
    document: string;
    update: string
}

type dataSapFosfecSate = {
    typeDoc: string;
    document: string;
}

type dataConsulDocs = {
    campo: string;
    tipoCampo: number;
    valor: string;
}


export { getDdlMasters, getRegistry, getSapFosfecState, saveFormFosfec, consultDocuments , getBpByTypeDocAndDoc};
